module.exports = __webpack_public_path__ + "static/media/kkd-multi-marketing.e70335ca.png";